import { Component, OnInit, OnDestroy } from '@angular/core';
import { ScriptService } from 'src/raksme/services/scripts/script.service';
import { Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { WidgetsService } from 'src/raksme/services/widgets/widgets.service';

declare var $: any;
declare var jQuery: any;
declare var gtag;

@Component({
  selector: 'raksme-footer',
  templateUrl: './raksme.footerView.html',
  styleUrls: ['./raksme.footerStyle.css']
})
export class FooterComponent implements OnInit, OnDestroy {
  title = 'rak-sme';

  public subscriptions: Subscription[] = [];

  private s1: any;
  private s3: any;
  private s4: any;
  private s5: any;


  private gtag: any;

  public settingsData: any = [];
  public analyticsid: any = '';
 
  constructor(private _renderer2: Renderer2, @Inject(DOCUMENT) private _document, private router: Router, private widgetService: WidgetsService){
  }

  

  ngOnInit(){

    let bodyData: object = {
      column: "ga_view_id"
    }
    this.subscriptions.push(
      this.widgetService.getWSettings('settings', bodyData).subscribe(
        res => {
          this.settingsData = res;
          this.analyticsid = this.settingsData?.data?.[0]?.ga_view_id;

          //gtag - only when an id was actually configured
          if (this.analyticsid) {
          this.gtag = this._renderer2.createElement('script');
          this.gtag.src = `https://www.googletagmanager.com/gtag/js?id=${this.analyticsid}`;
          this.gtag.async = true;
          this._renderer2.appendChild(this._document.head, this.gtag);
          }

          //
          const navEndEvent$ = this.router.events.pipe(
            filter(e=> e instanceof NavigationEnd)
          );
          navEndEvent$.subscribe((e: NavigationEnd)=>{
            gtag('config', this.analyticsid, {'page_path':e.urlAfterRedirects});
          });
        },
        error => console.log(error)
      )
    )

    this.loadScripts();

    
    
    
  }


  // jQuery and custom.js are bundled via angular.json now, rather than
  // injected here. custom.js runs at bundle time and needs jQuery already
  // present, and the Arabic gallery calls loadGallery() on a timer that
  // used to race this injection. The rest still load at runtime, after the
  // bundle, so they still find jQuery where they expect it.
  loadScripts() {

      const versionUpdate = (new Date()).getTime();

      this.s1 = this._renderer2.createElement('script');
      this.s1.src = location.origin+'/assets/vendors/modernizr.min.js?v=' + versionUpdate;
      this.s1.type = `text/javascript`;
      this.s1.async = true;
      this.s1.charset = 'utf-8';
      this._renderer2.appendChild(this._document.body, this.s1);


      this.s3 = this._renderer2.createElement('script');
      this.s3.src = location.origin+'/assets/js/theme-vendors.js?v=' + versionUpdate;
      this.s3.type = `text/javascript`;
      this.s3.async = false;
      this.s3.charset = 'utf-8';
      this._renderer2.appendChild(this._document.body, this.s3);

      this.s4 = this._renderer2.createElement('script');
      this.s4.src = location.origin+'/assets/vendors/pagePiling/dist/jquery.pagepiling.min.js?v=' + versionUpdate;
      this.s4.type = `text/javascript`;
      this.s4.async = false;
      this.s4.charset = 'utf-8';
      this._renderer2.appendChild(this._document.body, this.s4);

      this.s5 = this._renderer2.createElement('script');
      this.s5.src = location.origin+'/assets/js/theme.min.js?v=' + versionUpdate;
      this.s5.type = `text/javascript`;
      this.s5.async = false;
      this.s5.charset = 'utf-8';
      this._renderer2.appendChild(this._document.body, this.s5);


      // No stylesheet is injected here any more. en-style.css,
      // raksme-theme.css (which now includes the old themes/original.css) and the RTL override
      // (raksme-rtl.css) are all in the angular.json styles bundle.
      //
      // Injecting a sheet from here was the mechanism behind three separate
      // bugs, because it always landed AFTER every bundled sheet and so won
      // the cascade by position: it re-downloaded 662KB of en-style.css per
      // footer render, pushed a duplicate :root block that made which
      // --color-primary won depend on render timing, and masked the contrast
      // fix on Arabic pages. Keep stylesheets in the bundle.


      
      
    
  }

  

  ngOnDestroy(){

    // Every one of these can be undefined at destroy time. The scripts are
    // created in loadScripts() and gtag inside a settings subscribe, so
    // navigating away before those resolve used to throw
    // "Cannot read properties of undefined (reading 'parentNode')" out of
    // removeChild - which looked like an animation-teardown problem and is not.
    const dropFromBody = (el: any) => { if (el) { this._renderer2.removeChild(this._document.body, el); } };
    const dropFromHead = (el: any) => { if (el) { this._renderer2.removeChild(this._document.head, el); } };

    dropFromBody(this.s1);
    dropFromBody(this.s3);
    dropFromBody(this.s4);
    dropFromBody(this.s5);
    dropFromHead(this.gtag);

    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
